// eslint-disable-next-line import/prefer-default-export
export const SET_QUIZ_DATA = 'SET_QUIZ_DATA';
export const SET_QUIZ_STATE = 'SET_QUIZ_STATE';
